





















import { Component, Mixins, Prop, } from "vue-property-decorator";
import { ITreeExpandable } from "../../../../../base/components/system";
import {
  ICancelSelectFormatTree,
  IEditFormatTree,
} from "../../../../../documaker/components/format/selectors/trees";
import EditableFormatSummariesTreeSelector from "./EditableFormatSummariesTreeSelector.vue";
import { EditableFormatSummaryTreeEditDialog } from "./dialogs";
import { FormatTreeSourceSelectableMixin } from "./mixins";

@Component({
  components: {
    selector: EditableFormatSummariesTreeSelector,
    editDialog: EditableFormatSummaryTreeEditDialog,
  }
})
export default class EditableFormatSummariesSelector extends Mixins(FormatTreeSourceSelectableMixin) implements ITreeExpandable, ICancelSelectFormatTree, IEditFormatTree {
  $refs!: {
    selector: EditableFormatSummariesTreeSelector,
    editDialog: EditableFormatSummaryTreeEditDialog
  };
  
  @Prop({ default: false })
  shouldShowEmptyFolder: boolean;

  expandTree(): void {
    this.expandSelectorTree(this.$refs.selector);
  }

  requestTreeNodeSelectStatus(): void {
    this.$refs.selector.requestTreeNodeSelectStatus();
  }

  cancelSelectFormatTree(): void {
    if (!this.isLoaded) {
      return;
    }
    this.$refs.selector.cancelSelectFormatTree();
  }

  async editFormatTree(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    await this.$refs.editDialog.show();
    await this.loadTree();
  }

  async needReloaded(): Promise<void> {
    await this.loadTree();
    this.$refs.editDialog.reload();
  }
}
